import React, { useContext, useState } from "react";
import { Paper, InputBase, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { ToastContext } from "../utils/ToastContext";

const MUISearchBar = ({ onSearch, placeholder, forType = "lead" }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const { showToast } = useContext(ToastContext);

  const handleSearch = () => {
    if (searchTerm.length > 0) {
      if (forType === "user" || forType === "communicationTemplate") {
        onSearch(searchTerm);
      } else {
        const numericSearchTerm = searchTerm.replace(/\D/g, "");
        onSearch(numericSearchTerm);
      }
      setIsSearch(true);
    } else {
      showToast("Enter search term", "warning");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    } else if (event.key === "Backspace") {
      // console.log('backspace');
      setIsSearch(false);
    }
  };

  const handleOnChange = (event) => {
    if (forType === "user") {
      setSearchTerm(event.target.value);
    } else if (forType === "communicationTemplate") {
      const textOnly = event.target.value.replace(/[^a-zA-Z0-9_\-\s]/g, "");
      setSearchTerm(textOnly);
    } else {
      const numericValue = event.target.value.replace(/\D/g, "").slice(0, 10);
      setSearchTerm(numericValue);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    if (isSearch) {
      setIsSearch(false);
      onSearch("");
      showToast("Search has been cleared", "info");
    }
  };

  const handleIconClick = () => {
    if (searchTerm) {
      if (isSearch) {
        handleClearSearch();
      } else {
        handleSearch();
      }
    }
  };

  return (
    <Paper
      component="form"
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width:
          forType === "communicationTemplate"
            ? 290
            : {
                xs: 200,
                sm: 200,
                md: 200,
                lg: 200,
                xl: 200,
              },
        height: {
          xs: 35,
          sm: 35,
          md: 35,
          lg: 35,
          xl: 35,
        },
      }}
    >
      <InputBase
        sx={{
          flex: 1,
          outline: "none",
          height: 40,
          "& .MuiInputBase-root": {
            height: 40,
            border: "0.5px solid #b3b5b9",
            padding: "0px",
          },
          "& .MuiInputBase-input": {
            border: "none",
            height: 40,
            padding: "0 8px",
          },
        }}
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
      />
      <IconButton
        type="button"
        sx={{ color: "#3A36DB" }}
        aria-label={searchTerm ? (isSearch ? "clear" : "search") : "search"}
        onClick={handleIconClick}
      >
        {searchTerm && isSearch ? <ClearIcon /> : <SearchIcon />}
      </IconButton>
    </Paper>
  );
};

export default MUISearchBar;